/**
 * State of editing the full address.
 * @param dto dto to edit.
 * @param onDone callback to invoke when editing is done.
 * @param onCancel callback to invoke when editing is cancelled.
 */
define([], () => ({dto, onDone, onCancel}) => {
    return {
        dto,
        cancel: onCancel,
        accept: onDone,
        get isValid() {
            return dto.addressLine1.aspects.valid && dto.city.aspects.valid &&
                dto.state.aspects.valid && dto.postalCode.aspects.valid;
        }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/EditAddressState.js
 **/